import { WifiOff } from "lucide-react";
import { useOnline } from "@/lib/pwa";

export function OfflineScreen() {
  const online = useOnline();
  if (online) return null;
  return (
    <div className="fixed inset-0 z-[100] flex flex-col items-center justify-center gap-5 bg-[#1B2A4A] px-8 text-center text-white" data-testid="offline-screen">
      <WifiOff className="h-10 w-10 text-[#C9A84C]" />
      <p className="max-w-sm text-lg leading-relaxed">Necesitas conexión a internet para ver tus números y usar tu mentor.</p>
      <button type="button" onClick={() => window.location.reload()} className="rounded-full bg-[#C9A84C] px-6 py-3 text-sm font-bold text-[#1B2A4A]" data-testid="offline-retry">Reintentar</button>
    </div>
  );
}
